import BaseModal from "../../BaseComponents/BaseModal/BaseModal";
import styles from "./ConfirmSaveModal.module.css";

const ConfirmSaveModal = ({ open, onClose, onConfirm, loading }) => {
  return (
    <BaseModal
      open={open}
      onClose={onClose}
      title="Save Company Settings"
      width="460px"
      footer={
        <>
          <button
            className={styles.cancelBtn}
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className={`${styles.confirmBtn} ${loading ? styles.confirmBtnLoading : ""}`}
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className={styles.spinner} aria-hidden />
                Saving…
              </>
            ) : (
              "✓ Confirm & Save"
            )}
          </button>
        </>
      }
    >
      <div className={styles.body}>
        <div className={styles.warningBox}>
          <span className={styles.warningIcon}>⚠️</span>
          <div>
            <div className={styles.warningTitle}>Important</div>
            <div className={styles.warningText}>
              These changes will apply to all{" "}
              <strong>future documents</strong> (invoices, vouchers,
              confirmations). Historical documents will not be affected.
            </div>
          </div>
        </div>
        <div className={styles.infoBox}>
          ✓ All changes will be audit-logged with your user identity and
          timestamp.
        </div>
      </div>
    </BaseModal>
  );
};

export default ConfirmSaveModal;